import { Box, CircularProgress, Backdrop, Tooltip } from '@mui/material';
import { Card, CardContent, Typography } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import SchoolIcon from '@mui/icons-material/School';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MoneyIcon from '@mui/icons-material/Money';
import AttendanceSummary from './Dashboard/AttendanceSummary';
import FeeCollectionProgress from './Dashboard/FeeCollectionProgress';
import GenderActivity from './Dashboard/GenderActivity';
//import AttendanceSlider from './Dashboard/AttendanceSlider';
import { dashboard } from '../features/dashboard/dashboardSlice';
import { getClasses } from '../features/classes/ClassSlice';
import ClassWiseEnrollment from './Dashboard/ClassWiseEntrollment';
import ExamResultReport from './Dashboard/ExamResultReports';
import NoticeBoard from './Dashboard/NoticeBoard';
import { LuHandCoins } from 'react-icons/lu';
import { GiPayMoney } from 'react-icons/gi';
import { BsClockHistory } from 'react-icons/bs';
const DashboardAnalytics = () => {
  const { logo } = useSelector((state) => state.auth.successData);
  const dashboardData = useSelector((state) => state.dashboard.DashboardData);
  let { smsService, userName } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const [loading, setLoading] = useState(true);
  const [classesData, setClassesData] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      await dispatch(dashboard()).unwrap();
      const data = await dispatch(getClasses()).unwrap();
      Array.isArray(data) ? setClassesData(data) : setClassesData([]);
      setLoading(false);
    })();
  }, []);
  const statsData = [
    {
      Icon: <MoneyIcon />,
      title: 'Total Fee Amount',
      value: `₹${new Intl.NumberFormat('en-IN').format(dashboardData?.feedetails?.[0]?.value ?? '--')}`,
      color: '#2563EB',
      bgColor: '#dbeafe',
    },
    {
      Icon: <LuHandCoins size='24' />,
      title: 'Total Collections',
      value: `₹${new Intl.NumberFormat('en-IN').format(dashboardData?.feedetails?.[1]?.value ?? '--')}`,
      color: '#24A192',
      bgColor: 'rgba(36,161,146,0.1)',
    },
    {
      Icon: <MoneyIcon />,
      title: 'Fee Due',
      value: `₹${new Intl.NumberFormat('en-IN').format(dashboardData?.feedetails?.[2]?.value ?? '--')}`,
      color: '#F59E0B',
      bgColor: '#fef3c7',
    },
    {
      Icon: <GiPayMoney size='25' />,
      title: 'Write-off',
      value: `₹${new Intl.NumberFormat('en-IN').format(dashboardData?.feedetails?.[3]?.value ?? '--')}`,
      color: '#EF4444',
      bgColor: '#fee2e2',
    },
    {
      Icon: <BsClockHistory size='25' />,
      title: 'Pending Due',
      value: `₹${new Intl.NumberFormat('en-IN').format(dashboardData?.feedetails?.[4]?.value ?? '--')}`,
      color: '#10B981',
      bgColor: '#d1fae5',
    },
  ];
  function StatCard({ title, value, color, bgColor, Icon }) {
    return (
      <Card className='h-[90px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
        <CardContent className='flex gap-3 items-start p-[14px]'>
          <Box
            className={`flex items-center justify-center p-[5px] rounded-lg shrink-0`}
            style={{ backgroundColor: bgColor }}
          >
            <Box style={{ color }}>{Icon}</Box>
          </Box>
          <Box className='flex flex-col '>
            <div className=' text-[#272727] xl:text-[18px] leading-tight'>
              {title}
            </div>

            <div className='capitalize font-bold text-[#1e3a8a]  lg:text-lg leading-normal'>
              {value}
            </div>
          </Box>
        </CardContent>
      </Card>
    );
  }
  return (
    <>
      <Box className=' h-full relative max-h-full overflow-auto'>
        {loading ? (
          <Backdrop
            open
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              width: '100%',
              height: '100vh',
            }}
            className='bg-white'
          >
            <div>
              <div className='flex flex-col items-center gap-2 text-center sticky top-1/2'>
                <CircularProgress color='primary' />
                <div className='text-center '>
                  Fetching Dashboard Details...
                </div>
              </div>
              <br />
            </div>
          </Backdrop>
        ) : !dashboardData ? (
          <div className='flex justify-center items-center size-full'>
            <h4> No Data,Error in Fetching Dashboard Detials</h4>
          </div>
        ) : (
          <>
            {!loading && (
              <div className=' bg-[#F8F9FC] min-h-screen  lg:p-4 p-3 rounded'>
                {/* Row1 */}
                <div className='grid grid-cols-1 md:grid-cols-2 min-[800px]:grid-cols-3  xl:grid-cols-[40fr_17fr_17fr_26fr]  my-2  gap-2  '>
                  {/* Welcome Banner */}
                  <div className='md:col-span-2  min-[800px]:col-span-3 xl:col-span-1 '>
                    <Card className=' flex flex-col gap-2    bg-gradient-to-r from-blue-100 to-blue-300  min-h-[120px] shadow-none rounded-lg  overflow-visible '>
                      {logo ? (
                        <img
                          src={`data:image/jpeg;base64,${logo}`}
                          className=' h-full w-[160px] md:hidden mx-auto object-contain'
                        />
                      ) : (
                        <img
                          src={'/images/SVClassEdge.png'}
                          className=' h-full w-[168px]  md:hidden mx-auto object-contain'
                        />
                      )}
                      <div className='flex justify-between items-center gap-1 my-auto'>
                        <CardContent className='pt-1  lg:pt-7 pl-2  pr-0 w-full'>
                          <Typography
                            variant='h6'
                            className='capitalize font-bold text-[#1e3a8a]   w-full max-md:text-center'
                          >
                            Welcome back, {userName} 👋
                          </Typography>
                          <Typography className='font-medium text-[#667399] md:max-w-[400px]  max-md:text-center'>
                            Everything you need to manage your institution
                            efficiently
                          </Typography>
                        </CardContent>
                        <div className=' min-w-[160px] max-md:hidden'>
                          {logo ? (
                            <img
                              src={`data:image/jpeg;base64,${logo}`}
                              className='h-[135px] w-[160px]  object-contain'
                            />
                          ) : (
                            <img
                              src={'/images/SVClassEdge.png'}
                              className=' h-[135px] w-[160px] z-10  pr-0 object-contain'
                            />
                          )}
                        </div>
                      </div>
                    </Card>{' '}
                  </div>
                  {/* Attendacne Today */}
                  <div className='w-full'>
                    <Card className=' h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
                      <CardContent className='pt-6 '>
                        <Box className='text-center'>
                          <Box className='flex gap-[11px] items-center'>
                            <Box className='bg-[#dbeafe] flex items-center justify-center p-[5px] rounded-lg size-10'>
                              <DateRangeIcon className='text-[#2563EB] text-[22px]' />
                            </Box>
                            <div className=' text-left ml-2 text-[#272727] lg:text-lg '>
                              Today Attendance
                            </div>
                          </Box>
                          <Typography className=' text-[#1e3a8a] lg:text-lg font-semibold  text-center'>
                            {dashboardData?.attendance || 0}%
                          </Typography>
                        </Box>
                        {/* <AttendanceSlider
                        value={dashboardData?.attendance || 0}
                      /> */}
                      </CardContent>
                    </Card>
                  </div>
                  {/* Total Students */}
                  <Card className=' w-full h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
                    <CardContent className='pt-6 px-[14px]'>
                      <Box className='flex gap-[11px] items-center mb-1'>
                        <Box className='bg-[#fcedf6] flex items-center justify-center p-[5px] rounded-lg size-10'>
                          <SchoolIcon className='text-[#C35D9C]' />
                        </Box>
                        <div className=' text-left ml-2 text-[#272727] lg:text-lg'>
                          Total Students
                        </div>
                      </Box>
                      <Typography className="capitalize font-['Poppins:Bold',sans-serif] text-[#1e3a8a] lg:text-lg text-center font-semibold">
                        {dashboardData?.totalNumberOfStudents}
                      </Typography>
                    </CardContent>
                  </Card>

                  {/* SMS Overview */}
                  <Tooltip
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        backgroundColor: 'white', // amber-500
                        color: 'blue',
                        fontSize: '0.875rem',
                      },
                    }}
                    title={
                      <div className=''>
                        {smsService
                          ? dashboardData?.sms?.smsCount >=
                            dashboardData?.sms?.totalSms
                            ? 'Please Renew the SMS Service'
                            : `${parseInt(
                                dashboardData?.sms?.totalSms
                                  ? (dashboardData?.sms?.smsCount /
                                      dashboardData?.sms?.totalSms) *
                                      100
                                  : 0,
                              )}% Completed`
                          : 'Please contact admin or sales@support to get Service'}
                      </div>
                    }
                  >
                    <Card
                      className={`w-full  border-red-600 h-[136px] rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]  ${smsService ? '' : 'blur-[1px]'}   `}
                      style={{
                        backgroundImage:
                          'linear-gradient(136.554deg, rgb(31, 110, 205) 30.308%, rgb(52, 104, 255) 98.315%)',
                      }}
                    >
                      <CardContent className='pt-3 px-4'>
                        <Typography className="capitalize font-['Inter:Semi_Bold',sans-serif] text-[15px] text-white mb-1 font-semibold">
                          SMS Overview
                        </Typography>

                        <Box>
                          <Typography className="font-['Inter:Regular',sans-serif] text-white text-[11px]  font-light ">
                            Total SMS Used
                          </Typography>

                          <Box className='flex justify-between items-start'>
                            <Typography className="font-['Inter:Semi_Bold',sans-serif] text-white   font-semibold">
                              {`${dashboardData?.sms?.smsCount} /
                              ${dashboardData?.sms?.totalSms}`}
                            </Typography>
                            <Typography className="font-['Inter:Regular',sans-serif] text-white">
                              {parseInt(
                                dashboardData?.sms?.totalSms
                                  ? (dashboardData?.sms?.smsCount /
                                      dashboardData?.sms?.totalSms) *
                                      100
                                  : 0,
                              )}
                              %
                            </Typography>
                          </Box>
                        </Box>
                        <Box className='bg-[#e1e4ed]  border-[#f1f3f7] h-[35px]  mt-2 flex gap-[2px] mb-1 p-1'>
                          {Array.from({
                            length: parseInt(
                              dashboardData?.sms?.smsCount /
                                (dashboardData?.sms?.totalSms / 20),
                            ),
                          }).map((_, i) => (
                            <Box
                              key={i}
                              className='h-[27px] flex-1'
                              style={{
                                backgroundImage:
                                  'linear-gradient(150.459deg, rgb(78, 159, 255) 2.1374%, rgb(35, 136, 255) 97.964%)',
                              }}
                            />
                          ))}
                          {Array.from({
                            length:
                              20 -
                              parseInt(
                                dashboardData?.sms?.smsCount /
                                  (dashboardData?.sms?.totalSms / 20),
                              ),
                          }).map((_, i) => (
                            <Box
                              key={i}
                              className='bg-[#f6faff] h-[27px] flex-1'
                            />
                          ))}
                        </Box>
                      </CardContent>
                    </Card>
                  </Tooltip>
                </div>
                {/* Row 2 */}
                <div className=' grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2 mb-3'>
                  {statsData?.map((stat, index) => (
                    <div key={index} className='flex-1'>
                      <StatCard {...stat} />
                    </div>
                  ))}
                </div>
                {/* Row 3 */}
                <div className='grid  grid-cols-1 min-[900px]:grid-cols-3   xl:grid-cols-[48fr_26fr_26fr] gap-2 mb-3'>
                  <div className=' min-[900px]:col-span-2 xl:col-span-1 min-w-0'>
                    <AttendanceSummary
                      AttendanceData={dashboardData?.attendanceSummary}
                      classesData={classesData}
                    />
                  </div>
                  <div className=' min-[900px]:col-span-1 '>
                    <FeeCollectionProgress
                      FeeData={dashboardData?.feedetails}
                    />
                  </div>
                  <div className='min-[900px]:col-span-1 '>
                    <GenderActivity
                      GenderDetails={dashboardData?.genderOverview}
                      classesData={classesData}
                    />
                  </div>{' '}
                  <div className='min-[900px]:col-span-2 xl:hidden '>
                    <ClassWiseEnrollment
                      Data={dashboardData?.studentEnrollement}
                    />
                  </div>
                </div>

                {/* Row 4 */}
                <div className='grid  grid-cols-1 min-[900px]:grid-cols-2   xl:grid-cols-[48fr_32fr_20fr] gap-2 mb-3'>
                  <div className=' xl:col-span-1 min-w-0 max-xl:hidden '>
                    <ClassWiseEnrollment
                      Data={dashboardData?.studentEnrollement}
                    />
                  </div>
                  <div className='min-[900px]:col-span-1 min-w-0 '>
                    <ExamResultReport
                      ExamData={dashboardData?.examResultReport}
                      classesData={classesData}
                    />
                  </div>
                  <div className='min-[900px]:col-span-1 min-w-0'>
                    <NoticeBoard NoticesData={dashboardData?.notices} />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Box>
    </>
  );
};
export default DashboardAnalytics;
